export default {
  ja: {
    outline: {
      heading: 'OUTLINE',
      name: '名称',
      name_text: 'NAKED夜さんぽ™ 石川・那谷寺',
      period: '開催期間',
      period_text: '開催日：2025年10月3日(金)〜5日(日)、10日(金)〜13日(月・祝)、17日(金)〜19日(日)、23日(木)〜26日(日)',
      period_note: '※会期中無休（雨天催行、荒天時は中止の可能性あり） \n' +
        '※万が一の中止等は公式サイトや公式Instagramにてお知らせします。 \n' +
        '※都合により内容は予告なく変更する場合があります。',
      time: '時間',
      time_text: '17:00-21:00（最終受付20:30）',
      place: '会場',
      place_text: '那谷寺\n' +
        '石川県小松市那谷町ユ１２２',
      price: '入場料金',
      price_button: '詳細はこちら',
      price_url: '#tickets',
      contact: 'お問い合わせ',
      contact_text: '株式会社コムレイド\n' +
        '石川県小松市白江町ロ１０５−６\n' +
        'event-natadera@com-rade.co.jp\n' +'\n' +
        'ーお問い合わせ電話番号\n' +
'TEL：0761-48-5855\n' +
'※イベント開催日のみ対応\n' +
'平日：10:00〜21:00\n' +
'土日祝：16:00〜21:00',
    },
    access: {
      heading: 'アクセス',
      map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3214.946950713065!2d136.41740441206758!3d36.31359327227472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff859c1ffefc85f%3A0xae754d6bf16867e4!2z6YKj6LC35a-6!5e0!3m2!1sja!2sjp!4v1723621076294!5m2!1sja!2sjp',
      lang: 'jp',
      lead: '・車でのアクセス\n' +
        '「小松IC」より車で約30分\n' +
        '「加賀IC」より車で約30分\n' + '\n' +
        '・タクシーでのアクセス\n' +
        '「粟津駅」より約10分\n' +
        '「加賀温泉駅」より約20分\n' +
        '「小松駅」より約30分',
      title: '駐車場',
      parking_url: '',
      parking_button: '詳細はこちら',
      dd1: '那谷寺第1駐車場\n' +
        '住所：石川県小松市那谷町ユ１２２\n' +
        '営業時間…17:00〜21:00\n' +
        '収納台数…乗用車200台\n' +
        '駐車料金…無料\n' + '\n' +
        '那谷寺第2駐車場\n' +
        '住所…石川県小松市那谷町キ４７\n' +
        '営業時間…17:00〜21:00\n' +
        '収納台数…乗用車10台\n' +
        '駐車料金…無料\n' + '\n' +
        '那谷町会館\n' +
        '住所…石川県小松市那谷町ル148-5\n' +
        '営業時間…17:00〜21:00\n' +
        '収納台数…乗用車30台\n' +
        '駐車料金…無料\n' + '\n' +
        '那谷寺カントリー倶楽部（ゴルフ場）\n' +
        '住所…石川県小松市那谷町5-30\n' +
        '営業時間…17:00〜21:00　\n' +
        '収納台数…乗用車250台\n' +
        '駐車料金…無料',
      dd2: '※駐車場を含む敷地内で発生した盗難、事故、破損等に関して管理者は一切の責任を負いません。',
      dd3: '',
    },
  },
  en: {
    outline: {
      heading: 'OUTLINE',
      name: 'Event Title',
      name_text: 'NAKED\'s Night Walk™ Ishikawa Natadera Temple',
      period: 'Event Period',
      period_text: '※October 3 (Fri), 4 (Sat), 5 (Sun), 10 (Fri), 11 (Sat), 12 (Sun), 13 (Mon / Holiday), 17 (Fri), 18 (Sat), 19 (Sun), 23 (Thu), 24 (Fri), 25 (Sat), 26 (Sun)\n' +
        '※Please note that the content may be subject to change due to unforeseen circumstances.',
      period_note: '*Open every day throughout the event period (may be canceled due to harsh weather conditions)\n' +
        '*In the unlikely event of cancellation, etc., we will inform you via the event\'s official Instagram account .\n' +
        '*The event content may be subject to change without notice.',
      time: 'Hours',
      time_text: '17:00-21:00（last admission at 20:30）',
      place: 'Venue',
      place_text: 'Natadera Temple\n' +
        'Yu-122, Nata-machi,  Komatsu City, Ishikawa 923-0336 Japan',
      price: 'Admission fees',
      price_button: 'Click here for more details',
      price_url: '#tickets',
      contact: 'Inquiries about tickets',
      contact_text: 'Comrade Inc.\n' +
        '105-6 Ro, Shiraemachi, Komatsu City, Ishikawa Prefecture, Japan\n' +
        'event-natadera@com-rade.co.jp',
      contact_text2: '',
    },
    access: {
      heading: 'ACCESS',
      map: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3214.9469495697176!2d136.4174044!3d36.3135933!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff859c1ffefc85f%3A0xae754d6bf16867e4!2sNatadera%20Temple!5e0!3m2!1sen!2sjp!4v1723621163869!5m2!1sen!2sjp',
      lang: 'en',
      lead: '・Access by car\n' +
        'Approximately 30 minutes by car from the Komatsu IC\n' +
        'Approximately 30 minutes by car from Kaga IC\n' + '\n' +
        '・Access by taxi\n' +
        'Approximately 10 minutes from Awazu Station\n' +
        'Approximately 20 minutes from Kagaonsen Station\n' +
        'Approximately 30 minutes from Komatsu Station',
      title: 'Parking',
      parking_url: '',
      parking_button: 'Click here for more details',
      dd1:
        'Natadera Temple Parking Lot 1 \n' +
        'Address: Yu-122, Natamachi, Komatsu City, Ishikawa Prefecture \n' +
        'Hours: 17:00–21:00 \n' +
        'Capacity: 200 cars \n' +
        'Fee: Free\n' + '\n' +
        'Natadera Temple Parking Lot 2 \n' +
        'Address: Ki-47, Natamachi, Komatsu City, Ishikawa Prefecture\n' +
        'Hours: 17:00–21:00 \n' +
        'Capacity: 10 cars \n' +
        'Fee: Free\n' + '\n' +
        'Natamachi Community Hall Parking Lot \n' +
        'Address: Ru-148-5, Natamachi, Komatsu City, Ishikawa Prefecture \n' +
        'Hours: 17:00–21:00 \n' +
        'Capacity: 30 cars \n' +
        'Fee: Free\n' + '\n' +
        'Natadera Country Club Parking Lot \n' +
        'Address: 5-30, Natamachi, Komatsu City, Ishikawa Prefecture \n' +
        'Hours: 17:00–21:00 \n' +
        'Capacity: 250 cars \n' +
        'Fee: Free',
      dd2: '*The management assumes no responsibility or liability for any theft, accidents, damage, or other incidents occurring on the premises, including parking facilities.',
      dd3: '',
    },
  },

}
